import * as React from "react";
import PropType from "prop-types";

import HeaderBar from "./header-bar";
import HeroImage from "./hero-image";


const Header = () => {
  return (
    <header>
      <HeaderBar />
      <HeroImage />
    </header>
  );
};
Header.propTypes = {_: PropType.any};
Header.defaultProps = {};

export default Header;